module.exports = __webpack_public_path__ + "img/Deep Setting.efd877be.png";